import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as registrationActions from '../../actions/registrationActions';
import { registrationSelector } from '../../selectors';
import { ChangePassword } from '../../components/auth';
import { Modal, Button, Header } from 'semantic-ui-react';

class ChangePasswordPage extends Component {
    constructor(props){
        super(props);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
    }
    onFieldChange(e){
        const user = {...this.props.registration.user};
        user[e.target.name] = e.target.value;
        this.props.actions.updateUserRegistration(user);
    }
    onSubmit(e){
        const { oldPassword, password } = {...this.props.registration.user};
        this.props.actions.changePassword({ oldPassword, password });
    }
    onConfirm(){
        this.props.actions.hidePasswordChangedBox();
    }
    render() {
        const { user } = this.props.registration;
        return (
            <div>
                <Header as="h3" content="Change Password" color="red" />
                <Modal open={user.passwordChanged}>
                    <Modal.Header content="Password Changed" />
                    <Modal.Content content="Your password has been changed." />
                    <Modal.Actions actions={[<Button key="1" primary content="OK" onClick={this.onConfirm} />]} />
                </Modal>
                <ChangePassword onSubmit={this.onSubmit} onChange={this.onFieldChange} loading={user.loading} error={user.error} data={user} />
            </div>
        );
    }
}

ChangePasswordPage.propTypes = {
    actions: PropTypes.object.isRequired,
    registration: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
    return {
        registration: registrationSelector(state)
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        actions: { 
            ...bindActionCreators(registrationActions, dispatch)
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordPage);